import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/warehouseProvider',
  component: Layout,
  name: 'warehouseProvider',
  redirect: '/warehouseProvider/index',
  children: [{
    path: '/warehouseProvider/index',
    component: () => import('@/views/warehouseProvider/index'),
    name: 'warehouseProvider.index',
    meta: {
      title: i18n.t(`message.suppliers`)
    }
  }, ]
}

export default paymentType